import React from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import Footer from "../Component/Footer";
import bannerImage from "../Component/img/banner1.webp";
import { Helmet } from 'react-helmet';

const About = () => {
  return (
    <>


    <Helmet>
            <link rel="canonical" href="https://evventoz.com/about-us" />
            <title>About Us | Evventoz</title>
          </Helmet>
    
      <NavbarVisitor />

      {/* Banner */}
      <div
        className="about-banner text-white text-center d-flex align-items-center justify-content-center"
        style={{
          backgroundImage: `url(${bannerImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "300px",
          position: "relative",
        }}
      >
        <div className="overlay position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>
        <div className="position-relative z-1">
          <h1 className="display-4 fw-bold">About Evventoz</h1>
          <p className="lead">
            Your Gateway to Conferences, Tradeshows &amp; Corporate Events
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5 text-start">
        {/* Who We Are */}
        <div className="row mb-5">
          <div className="col-md-12 d-flex flex-column justify-content-center">
            <h2 className="fw-bold mb-3">Who We Are</h2>
            <p>
              <strong>Evventoz</strong> is a premier{" "}
              <strong>event discovery</strong> and publishing platform,
              specializing in the promotion and management of{" "}
              <strong>
                conferences, exhibitions, corporate events, seminars, summits,
                workshops, and sports events
              </strong>
              . Whether you&#39;re an <strong>event organizer</strong> or an
              attendee, we help you navigate and connect with the most impactful{" "}
              <strong>business events</strong> across industries.
            </p>
            <p>
              Our platform is built to connect attendees and organizers
              globally, enhancing the experience of planning and attending
              events with modern digital tools.
            </p>
          </div>
        </div>

        {/* Mission & Services */}
        <div className="row align-items-center mb-5">
          <div className="col-md-12 order-md-1 d-flex flex-column justify-content-center">
            <h2 className="fw-bold mb-3">What We Offer</h2>
            <ul className="list-unstyled fs-5">
              <p>
                ✅ <strong>Event Discovery &amp; Publishing</strong>: Promote
                your exhibitions, conferences, corporate seminars, tradeshows,
                and workshops with ease. From small business meetings to
                international summits, we help you reach a global audience.
              </p>
              <p>
                ✅{" "}
                <strong>Online Registration &amp; Real-Time Analytics</strong>:
                Simplify attendee registration and gain insights with our
                advanced analytics dashboard. Track performance and engagement
                for every event.
              </p>
              <p>
                ✅ <strong>Global Reach with Trusted Organizers</strong>: Join a
                growing network of over 250+ event organizers across 25+
                countries. Evventoz is trusted for hosting and promoting
                corporate events, sportsevents, and international summits.
              </p>
              <p>
                ✅ <strong>Featured Event Listings</strong>: Gain visibility
                through our platform, which attracts more than 5,000+ daily
                users searching for top business events, conferences, and
                workshops.
              </p>
              <p>
                ✅ <strong>Smart Networking Tools</strong>: Facilitate powerful
                connections between attendees, speakers, and exhibitors. Our
                platform helps leaders build communities that thrive long after
                the event ends.
              </p>
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="row mb-5">
          <div className="col-md-12 text-start">
            <h2 className="fw-bold mb-3">Get in Touch</h2>
            <p className="fs-5">
              Ready to elevate your next conference, tradeshow, or corporate
              events? Let’s collaborate.
            </p>
            <ul className="list-unstyled fs-5">
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.evventoz.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  www.evventoz.com
                </a>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:info@evventoz.com">info@evventoz.com</a>
              </p>
              <p>
                <strong>WhatsApp:</strong>{" "}
                <a
                  href="https://wa.me/918080243455"
                  target="_blank"
                  rel="noreferrer"
                >
                  +91 8080243455
                </a>
              </p>
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default About;
